import React, { Component } from 'react';
import firebase from 'firebase';
import { Link } from 'react-router-dom';
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import { TableHeaderColumn } from 'react-bootstrap-table';
import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import paginationFactory from 'react-bootstrap-table2-paginator';
import Modal_empleados from './Modal_empleados';
import Modal from 'react-modal';
import Modal_Empresa from './empresa_modal';
import Alert from 'react-s-alert';
import store from '../../store';
import Slide from '../Globals/Slide/slide'

const database = firebase.database();

const customStyles = {
	content: {
		top: '50%',
		left: '50%',
		right: 'auto',
		bottom: 'auto',
		transform: 'translate(-50%, -50%)',
		width: '450px',
		height: '550px',
	}
};

const { SearchBar } = Search;

class Emp_Empleados extends Component {

	constructor(props) {

		super(props);
		this.state = {
			empleados: [],
			isActive: false,
			empleadoKey: '',
			correo: '',
			dui: '',
			numero_empleado: '',
			pasaporte: '',
			estado: '',
			nodo_empresa: '',
			nombre_empresa: '',
			preferencia: '',
			isActiveCosto: false,
			nom: '',
			Costos: [],
			codCosto: '',
			area: '',
			filtrado: 'si',
			empresaUID: '',
			authUser: null,
		}
		this.handleClick = this.handleClick.bind(this);
		this.updateRow = this.updateRow.bind(this);
		this.toggleModalUpdate = this.toggleModalUpdate.bind(this);
		this.empleadosRef = database.ref().child('Clientes').orderByChild('socio').equalTo(store.getState().nodo_empresa);
		this.handleKeyPressDui = this.handleKeyPressDui.bind(this);
		this.ocultarMenu = this.ocultarMenu.bind(this);
		this.socio = store.getState().nodo_empresa;
		store.subscribe(() => {
			this.setState({
				nodo_empresa: store.getState().nodo_empresa,
				nombre_empresa: store.getState().nombre_empresa

			});
		});
	}

	componentWillMount() {
		Modal.setAppElement('body');
		let uid = firebase.auth().currentUser.uid;
		this.setState({ empresaUID: uid })
	}

	componentDidMount() {
		firebase.database().ref('CentroCosto').once('value').then(data => {
			let Datos = [];
			const Base = data.val();
			if (data.val() !== null) {
				const keys = Object.keys(Base);
				for (let i = 0; i < keys.length; i++) {
					const k = keys[i];
					if (Base[k].empresa === this.state.empresaUID) {
						Datos.push({
							key: k,
							codigo: Base[k].codigo,
							descripcion: Base[k].descripcion,
							responsable: Base[k].responsable,
							area: Base[k].area
						})
					}
				}
				this.setState({ Costos: Datos });
			}
		});
		this.empleadosRef.on('value', this.gotData, this.errData);
	}

	errDataSocios = (err) => {
		console.log(err);
	}

	gotData = (data) => {
		let newEmpleado = []
		let codigo;
		const empleadodata = data.val();
		if (empleadodata != null) {
			const keys = Object.keys(empleadodata);
			for (let i = 0; i < keys.length; i++) {
				const k = keys[i];
				for (let j = 0; j < this.state.Costos.length; j++) {
					if (this.state.Costos[j].key === empleadodata[k].centro) {
						codigo = this.state.Costos[j].codigo;
					}
				}
				newEmpleado.push({
					key: k,
					nombre: empleadodata[k].nombre + ' ' + empleadodata[k].apellido,
					correo: empleadodata[k].correo,
					dui: empleadodata[k].dui,
					numero_empleado: empleadodata[k].numero_empleado,
					pasaporte: empleadodata[k].pasaporte,
					estado: empleadodata[k].estado,
					preferencia: empleadodata[k].preferencia,
					centro: codigo,
					centroK: empleadodata[k].centro,
					area: empleadodata[k].areaDesc

				});
			}
			this.setState({ empleados: newEmpleado });
		}
	}
	errData = (err) => {
		console.log(err);
	}

	generateBtnEditar(cell, row) {
		return <button className="btn btn-success btn-sm" onClick={() => { this.handleClick(row) }} >Editar</button>;
	}

	ocultarMenu() {
		store.dispatch({
			type: 'STATE_MOSTRAR',
			mostrar: 'noMostrar'
		})
	}

	generateBtnEmpleados(cell, row) {
		let url = '/ver viajes/' + row.key;
		return <Link to={url} className="btn btn-info btn-sm">Ver Empleados</Link>;
	}

	toggleModalUpdate() {
		this.setState({

			isActive: !this.state.isActive
		});
	}

	updateRow(event) {
		let key = this.state.empleadoKey;
		let pasaporte = this.pasaporteEmpleado.value;
		let dui = this.duiEmpleado.value;
		let numero_empleado = this.numeroEmpleado.value;
		let estado = this.estadoEmpleado.value;
		let preferencia = this.preferencia.value;
		let centro = this.state.codCosto;
		let area = this.area.value;

		database.ref().child('Clientes').child(key).update({
			pasaporte: pasaporte,
			dui: dui,
			numero_empleado: numero_empleado,
			estado: estado,
			preferencia: preferencia,
			centro: centro,
			areaDesc: area
		})
		Alert.success('Datos actualizados correctamente', {
			effect: 'genie',
			position: 'bottom-right',
			timeout: 2000
		});
		this.toggleModalUpdate();
		event.preventDefault();
	}

	handleClick(row) {
		this.setState({
			empleadoKey: row.key,
			dui: row.dui,
			pasaporte: row.pasaporte,
			correo: row.correo,
			numero_empleado: row.numero_empleado,
			estado: row.estado,
			preferencia: row.preferencia,
			nom: row.centro,
			area: row.area,
			codCosto: row.centroK

		})
		this.toggleModalUpdate();
	}

	handleKeyPressDui(e) {
		let dui = this.duiEmpleado.value;
		let tecla = e.which;

		if (dui.length === 8) {
			if (!(tecla === 45)) {

				e.preventDefault();
			}
		} else {
			let patron = /^[0-9]+$/;
			let tecla_final = String.fromCharCode(tecla);
			let rs = patron.test(tecla_final);

			if (!rs) {
				e.preventDefault();
			}
		}
	}

	generateBtnVerViajes(cell, row) {
		let url = '/viajes/' + row.key;
		return <Link to={url} className="btn btn-info btn-sm">Ver Viajes</Link>;
	}

	toggleModalCosto = () => {
		this.setState({
			isActiveCosto: !this.state.isActiveCosto
		})
	}

	ocultarMenu() {
		store.dispatch({

			type: 'STATE_MOSTRAR',
			mostrar: 'noMostrar'
		})
	}

	btnCostosFormatter(cell, row) {
		return <button className="btn btn-success btn-sm" onClick={() => { this.handleClickCostos(row) }} >Seleccionar</button>;
	}

	handleClickCostos = (rowKey) => {
		this.state.nom = rowKey.codigo;
		this.state.codCosto = rowKey.key;
		this.toggleModalCosto();
	}

	render() {
		const rowClasses = 'table-bordered';
		const columns = [
			{
				dataField: 'key',
				hidden: true
			},
			{
				dataField: 'centroK',
				text: 'key',
				hidden: true
			},
			{
				dataField: 'nombre',
				text: 'Empleado',
				sort: true
			},
			{
				dataField: 'correo',
				text: 'Correo',
				sort: true
			},
			{
				dataField: 'dui',
				text: 'Dui',
			},
			{
				dataField: 'numero_empleado',
				text: 'Numero de empleado',
			},
			{
				dataField: 'pasaporte',
				text: 'Pasaporte',
			},
			{
				dataField: 'centro',
				text: 'Centro de Costo',
			},
			{
				dataField: 'estado',
				text: 'Estado',
			},
			{
				dataField: 'area',
				text: 'Area',
			},
			{
				dataField: 'ver',
				text: 'Editar',
				formatter: (cellContent, row) => (
					<button className="btn btn-success btn-sm" onClick={() => { this.handleClick(row) }} >Editar</button>
				)
			},
		];

		return (
			<div onClick={this.ocultarMenu}>
				<div className="empleados_empresa container" onClick={this.ocultarMenu}>

					<h1 className="titulo-empresas">{store.getState().nombre_empresa}</h1>
					<Modal_empleados nodo={store.getState().nodo_empresa} empleadosData={this.state.empleados} socio={this.socio} />
					
					<ToolkitProvider
						keyField="key"
						data={this.state.empleados}
						columns={columns}
						search={true}>
						{
							props => (
								<div>
									<div style={{ width: '30%', marginLeft: '70%' }}>
										<SearchBar {...props.searchProps} />
									</div>
									{/* <input style={{ width: '30%', 'margin-left': '70%' }} onChange={this.handleFiltering} className="form-control" placeholder='Busqueda' /> */}
									<hr />
									<BootstrapTable
										{...props.baseProps}
										pagination={paginationFactory()}
										striped
										hover
										condensed
										bordered
										classes="custom-table"
										rowClasses={rowClasses}
									/>
								</div>
							)
						}
					</ToolkitProvider>
					{/* <BootstrapTable data={ this.state.empleados }
				 ref='table'			 
				 pagination={ true }
				 search={ true }
				 >
				 <TableHeaderColumn dataField='key' isKey={true}  hidden >key</TableHeaderColumn>
				 <TableHeaderColumn dataField='centroK' hidden >key</TableHeaderColumn>
				 <TableHeaderColumn dataField='nombre' dataSort={true}>Empleado</TableHeaderColumn>
				 <TableHeaderColumn dataField='correo' dataSort={true}>Correo</TableHeaderColumn>
				 <TableHeaderColumn dataField='dui'>Dui</TableHeaderColumn>
				 <TableHeaderColumn dataField='numero_empleado' >Numero de empleado</TableHeaderColumn>
				 <TableHeaderColumn dataField='pasaporte' >Pasaporte</TableHeaderColumn>
				 <TableHeaderColumn dataField='centro' >Centro</TableHeaderColumn>
				 <TableHeaderColumn dataField='estado' >Estado</TableHeaderColumn>
				 <TableHeaderColumn dataField='area' >Area</TableHeaderColumn>
				 <TableHeaderColumn dataField='ver' dataAlign='center' dataFormat={ this.generateBtnVerViajes.bind(this) }>Ver Viajes</TableHeaderColumn>
				 <TableHeaderColumn dataField='ver' dataAlign='center' dataFormat={ this.generateBtnEditar.bind(this) }>Editar</TableHeaderColumn>
			  </BootstrapTable> */}

					<Modal isOpen={this.state.isActive} onRequestClose={this.toggleModalUpdate} style={customStyles}>

						<form method="POST" action="" onSubmit={this.updateRow}>

							<h3>Modificar Empleado</h3>
							<input type="hidden" name="key" value={this.state.empleadoKey} required />
							<hr />

							<div className="form-group">
								<label htmlFor="correo">Correo:</label>
								<input type="text" className="form-control" name="correo"
									placeholder="Correo" required autoComplete="off"
									value={this.state.correo}
									disabled="disabled"

								/>
							</div>

							<div className="form-group">
								<label htmlFor="numero_empleado">Numero de empleado:</label>
								<input type="text" className="form-control" name="numero_empleado"
									placeholder="Numero de empleado" required autoComplete="off"
									defaultValue={this.state.numero_empleado}
									ref={input => { this.numeroEmpleado = input; }}
								/>
							</div>

							<div className="form-group">
								<label htmlFor="dui">Dui:</label>
								<input type="text" className="form-control" name="dui"
									placeholder="Dui" required autoComplete="off"
									defaultValue={this.state.dui}
									ref={input => { this.duiEmpleado = input }}
									onKeyPress={this.handleKeyPressDui}
									maxLength="10" minLength="10" />
							</div>

							<div className="form-group">
								<label htmlFor="pasaporte">Pasaporte:</label>
								<input type="text" className="form-control" name="pasaporte"
									placeholder="Pasaporte" required autoComplete="off"
									defaultValue={this.state.pasaporte}
									ref={input => { this.pasaporteEmpleado = input }}
								/>

							</div>

							<div className="form-group">
								<label htmlFor="cento">Centro Costo</label>
								<input type="text" className="form-control"
									ref={input => { this.codCosto = input; }}
									readOnly="readonly" required autoComplete="off"
									onClick={this.toggleModalCosto}
									placeholder="Ejile una Centro de costos"
									value={this.state.nom}
								/>
							</div>

							<div className="form-group">
								<label htmlFor="estado">Estado:</label>
								<select name="estado" defaultValue={this.state.estado} className="form-control"
									ref={input => { this.estadoEmpleado = input }}
								>
									<option>Activo</option>
									<option>Inactivo</option>
								</select>
							</div>

							<div className="form-group">
								<label htmlFor="preferencia">Preferencia:</label>
								<select className="form-control"
									ref={input => { this.preferencia = input }}
									defaultValue={this.state.preferencia}
								>
									<option>Taxi</option>
									<option>Microbus</option>
									<option>Privado</option>
									<option>Todos</option>
								</select>
							</div>
							<div className="form-group">
								<label htmlFor="nombre">Area</label>
								<input type="text" className="form-control" name="nombre"
									defaultValue={this.state.area}
									placeholder="Area" required autoComplete="off"
									ref={input => { this.area = input }} />
							</div>
							<button className="btn btn-primary buttons" type="submit" >Guardar</button>
						</form>
						<button className="btn btn-default buttons btnmargin" onClick={this.toggleModalUpdate}>Cerrar</button>
					</Modal>
					<Modal isOpen={this.state.isActiveCosto} onRequestClose={this.toggleModalCosto} style={customStyles}>
						<h4>Selecciona un Centro de costos</h4>
						<hr />

						<BootstrapTable data={this.state.Costos}
							ref='table'
							pagination={true}
							search={true}
							hover
						>
							<TableHeaderColumn dataField='key' isKey={true} dataSort={true} hidden >Nombre</TableHeaderColumn>
							<TableHeaderColumn dataField='codigo' dataSort={true}  >Codigo</TableHeaderColumn>
							<TableHeaderColumn dataField='area' dataSort={true}  >Area</TableHeaderColumn>
							<TableHeaderColumn dataField='edit' dataAlign='center' dataFormat={this.btnCostosFormatter.bind(this)}>Seleccionar</TableHeaderColumn>
						</BootstrapTable>

					</Modal>
				</div>
			</div>
		);
	}
}
export default Emp_Empleados;


// WEBPACK FOOTER //
// ./src/Components/Emp_Empresas/Emp_Empleados.js